/*
* @params - str
* example - "USERNAME, usernAme, ..."
* return "Username"
* */
export const normalizeString = (str) => {
	if (str.length > 0)
		return str.replace(/\s/g, '')[0].toUpperCase() + str.replace(/\s/g, '').slice(1).toLowerCase();
};
